const id_whs_itemin = {
    "": "barang masuk",
}

export default id_whs_itemin;